import { LanguageSets, langCode } from '../../utils/getLangCode.js';
export type language = {
  locale: langCode;
  translations: translationSet;
};
export type translationSet = {
  barChart: string;
  missingData: string;
};
export const languages: LanguageSets<translationSet> = {
  en: {
    barChart: 'Bar chart',
    missingData: 'Missing data'
  },
  sv: {
    barChart: 'Stapeldiagram',
    missingData: 'Saknar data'
  },
  nb: {
    barChart: 'Stolpediagram',
    missingData: 'Manglende data'
  },
  fi: {
    barChart: 'Pylväsdiagrammi',
    missingData: 'Puuttuvat tiedot'
  },
  da: {
    barChart: 'Søjlediagram',
    missingData: 'Manglende data'
  }
};
export const getLanguage = (locale: langCode): language => {
  const translations = languages[locale];
  return {
    locale,
    translations
  };
};